import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { AuthGuard } from '../auth/auth-guard'

import { MovieDetailComponent } from './movie-detail/movie-detail.component'

const moviesRoutes: Routes = [
    { path: 'movies/:id', component: MovieDetailComponent, canActivate: [AuthGuard]}
]

@NgModule({
    imports: [
        RouterModule.forChild(moviesRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class MoviesRoutingModule { }



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/movies/movies-routing.module.ts